var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBookmarked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  fill: "#EEEEEE"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "black"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.5835 9.46493C26.1945 10.1082 26.5 10.8879 26.5 11.8026V27.5L18.0734 22.0076L9.5 27.5V11.8026C9.5 10.8879 9.8055 10.1082 10.4158 9.46493C11.0261 8.82232 11.7591 8.5 12.6139 8.5H23.3854C24.2409 8.5 24.9732 8.82232 25.5835 9.46493Z",
  fill: "black"
})));
export default SvgIconBookmarked;